export default {
  DEV: 'development',
  PROD: 'production',
  STAG: 'staging',
};
